import React, { useEffect, useRef, useState } from 'react'
import { ErrorModal } from '../../components/Modal'
import { useLocation } from 'react-router-dom'
import Button from '../../components/Button'
import Layout from '../../components/Layout'
import DownloadStyle from './DownloadStyle'
import logo from '../../assets/images/logo-2.png'
import html2PDF from 'html2pdf.js'
import { get } from 'lodash'
import api from '../../api'
import moment from 'moment'
import { useSelector } from 'react-redux'
import formatPhoneNumber from '../../helpers/PhoneWithSpaces'
import './print.css'
import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

const Download = () => {
	const { getMe } = useSelector((state) => state.main)
	const { t } = useTranslation()

	const location = useLocation()
	const errorRef = useRef()

	const dataLocation = get(location, 'state.data', {})
	const isNoutbuk = get(location, 'state.isNotebook', '')
	const isTablet = get(location, 'state.isTablet', '')
	const isMobilePhone = get(location, 'state.isMobilePhone', '')
	const isTechnique = get(location, 'state.isTechnique', '')
	const hasFirstPayment = get(location, 'state.fistPay', '')

	const [userData, setuserData] = useState({})
	const [paymentDates, setPaymentDates] = useState([])
	const [item, setItem] = useState()
	const [dollar, setDollar] = useState()
	const [invoice, setInvoice] = useState()
	const [userFields, setUserFields] = useState([])
	const [whsData, setWhsData] = useState([])

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingItem, setIsLoadingItem] = useState(false)
	const [isLoadingWhs, setIsLoadingWhs] = useState(false)
	const [isLoadingUser, setIsLoadingUser] = useState(false)
	const [isLoadingPayment, setIsLoadingPayment] = useState(false)
	const [isLoadingInvoice, setIsLoadingInvoice] = useState(false)

	const telephoneNum = userData?.U_Telephone?.includes(',')
		? userData?.U_Telephone?.split(',')
		: userData?.U_Telephone

	const color =
		get(item, 'U_Color', '') !== null
			? userFields
					?.find((item) => item.Name === 'Color')
					?.ValidValuesMD.find(
						(value) => get(item, 'U_Color', '') === value.Value,
					)?.Description || ''
			: ''

	const debtAmount = invoice?.DocTotal - paymentDates[0]?.InsTotal
	const installmentMonth = paymentDates ? paymentDates.length - 1 : '________'
	console.log('paymentDates', paymentDates)

	const paymentDate = paymentDates
		? moment(paymentDates[1]?.DueDate).format('DD')
		: '________'
	console.log('paymentDate ==>', paymentDate)

	const sotuvKursi =
		new Intl.NumberFormat('fr-FR').format(paymentDates[0]?.InsTotal * dollar) +
		'  '

	const oylikTolov = paymentDates ? paymentDates[1]?.InsTotal : '________'
	const vznos = new Intl.NumberFormat('fr-FR').format(paymentDates[0]?.InsTotal)
	const docTotal =
		new Intl.NumberFormat('fr-FR').format(invoice?.DocTotal) + '  '
	const imei = invoice?.DocumentLines[0]?.SerialNumbers[0]?.InternalSerialNumber
		? invoice.DocumentLines[0].SerialNumbers[0].InternalSerialNumber
		: '_______________'

	const fullItemName = item
		? `${`${item?.ItemName} ${color ?? ''} ${item?.U_Memory ?? ''} modeldagi, `}`
		: '{_____________________________'

	const whsNum = (whsCode) => {
		switch (whsCode) {
			case '01':
				return '+998	71 200 00 00'
			case '02':
				return '+998	71 200 00 00'
			case '03':
				return '+998	71 200 00 00'
			case '04':
				return '+998	71 200 00 00'

			default:
				break
		}
	}

	useEffect(() => {
		getUser()
		getInformationOfItem()
		getInfoOFDevice()
		userFieldsFn()
		getWhs()
	}, [])

	useEffect(() => {
		getUSD(paymentDates)
	}, [paymentDates])

	const userFieldsFn = () => {
		api
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM' ",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const formatPhoneNumber4 = (phoneNum) => {
		// Split the phoneNum by ',' and '"' and remove empty entries
		const parts = phoneNum.split(/[,]/).filter(Boolean)

		return parts.length > 4 ? parts.slice(0, 4).join(', ') : parts.join(', ')
	}

	const getInformationOfItem = () => {
		setIsLoading(true)
		api
			.get(
				`SQLQueries('getInstallments')/List?docEntry='${location.state.data.DocEntry}'`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=50',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				console.log('resData', resData)

				setPaymentDates(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoading(false)
			})
		// setIsLoading(false)
	}

	const getUser = () => {
		setIsLoadingUser(true)
		api
			.get(
				`BusinessPartners('${get(
					dataLocation,
					'CardCode',
					0,
				)}')?$select=CardCode,CardName,U_Telephone,Address,Phone1,Phone2,U_Gender,U_PS,BPAddresses,Fax`,
			)
			.then((res) => {
				const resData = JSON.parse(res.data)
				setuserData(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingUser(false)
			})
	}

	const getWhs = () => {
		setIsLoadingWhs(true)
		api
			.get(`Warehouses`)
			.then((res) => {
				const resData = JSON.parse(res.data).value
				setWhsData(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingWhs(false)
			})
	}

	const getUSD = (paymentDates) => {
		setIsLoadingPayment(true)
		api
			.get(
				`SQLQueries('getUSDRate')/List?date='${get(
					paymentDates[0],
					'DueDate',
					'',
				)}'`,
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setDollar(get(resData, '[0].Rate', 0))
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingPayment(false)
			})
	}

	const download = () => {
		let element = document.getElementsByClassName('contract')[0]

		// Ensure full width for PDF
		element.style.width = '210mm' // A4 width in mm
		element.style.maxWidth = '100%'

		html2PDF(element, {
			margin: [5, 0, 5, 0], // top, left, bottom, right margins in mm
			filename: 'contract.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: {
				scale: 2,
				logging: true,
				letterRendering: true,
				width: element.scrollWidth, // ensures full width is rendered
				windowWidth: element.scrollWidth,
			},
			jsPDF: {
				unit: 'mm',
				format: 'a4',
				orientation: 'portrait',
			},
			pagebreak: {
				before: ['.talon-section'], // Break before the warranty section
			},
		})
	}

	const getInfoOFDevice = () => {
		setIsLoadingInvoice(true)
		api
			.get(`Invoices(${location.state.data.DocEntry})`)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'DocumentLines[0]', [])
				setInvoice(JSON.parse(res.data))

				getItems(get(resData, 'ItemCode', ''))
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingInvoice(false)
			})
	}

	const getItems = (code) => {
		setIsLoadingItem(true)
		api
			.get(`Items('${code}')`)
			.then((res) => {
				const resDate = JSON.parse(res.data)
				setItem(resDate)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoadingItem(false)
			})
	}

	return (
		<Layout>
			<DownloadStyle>
				<Spin
					spinning={
						isLoadingInvoice ||
						isLoadingItem ||
						isLoadingUser ||
						isLoadingWhs ||
						isLoadingPayment ||
						isLoading
					}
				>
					<div className="flex justify-end">
						<Button
							onClick={download}
							btnStyle={{ marginBottom: 10, width: 200 }}
						>
							Загрузить договор
						</Button>
					</div>
					<div className="contract shadow-md">
						<div className="no-break">
							<h2 className="text-center">
								<b>TILXAT</b>
							</h2>

							{isMobilePhone && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Men</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										sotuvchi Abitov Murod Mansurovichdan Telefon turi:{' '}
										<span className="font-bold">{fullItemName}</span>
										IMEI kodi: <span className="font-bold">{imei}</span> bo’lgan
										telefonni pulini mudattli to’lov sharti bilan sotib oldim.
										Telefonning umumiy narxi{' '}
										<span className="font-bold">{docTotal}</span>
										dollari miqdorida bolib shundan{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										AQSH dollari miqdoridagi pulni SOTUV KURSI bo’yicha{' '}
										<span className="font-bold">
											{hasFirstPayment ? sotuvKursi : 0}
										</span>
										so’mda oldindan to’ladim. Qolgan {'  '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										AQSH dollari miqdoridagi pulni{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}{' '}
											oy
										</span>{' '}
										davomida har oyning{' '}
										<span className="font-bold">{paymentDate}</span>
										-sanasida <span className="font-bold">
											{oylikTolov}
										</span>{' '}
										AQSH dollari miqdoridagi pulni tijorat banklari sotuv kursi
										bo’yicha so’mda sotuvchi aytgan joyga va o’z vaqtidan
										kechiktirmay to’lab borilishini o’zim ta’minlayman.
										__________(imzo)
									</p>
									<p>
										<span className="ml-8"> Agar </span>
										men oylik to'lovlarni o'z vaqtida va to'liq miqdorda to'lay
										olmasam, telefonni sotuvchining birinchi talabidayoq
										bus-butun holda, hech qanday buzilishlarsiz o’zim qaytarib
										beraman. Telefonni sotuvchiga qaytarish qarzdorlik to’liq
										qoplanadi degani emas. Telefon sotuvchiga qaytarilgan
										vaqtida uning o’sha vaqtdagi holatiga qarab baholanadi va
										sotiladi. Shunda ham tilxatda ko’rsatilgan qarzim to’liq
										qoplanmasa, qolgan qarzdorlikni o’z vaqtidan kechiktirmay
										to’liq to’lab berishga majburman. Oylik to’lovlar muddatidan
										oldin to’liq to’langan taqdirda yoki muddatidan
										kechiktirilgan taqdirda ham tilxatda kelishilgan umumiy narx
										miqdori o’zgarmasligi haqida ogohlantirildim va shunga
										roziman. ____________(imzo)
									</p>
									<p>
										<span className="ml-8">Ushbu </span>
										tilxat bilan men muddatli to’lov asosida sotib olayotgan
										qurilmaga sotuvchi tomonidan qulflash tizimi o’rnatilishiga
										roziligimni bildiraman. O’rnatilgan tizim orqali qurilmaga
										va berilgan telefon raqamlariga oylik to’lovlar va
										qarzdorliklar haqidagi sms xabarlar jo’natilishiga roziman.
										Agar men oylik to'lovni belgilangan muddatdan 5 ish kuni
										mobaynida kechiktirsam yoki uni to'liq to'lamasam sotuvchi
										ushbu qurilmani masofadan qulflashiga roziman. Bir xaridor
										bir nechta qurilma xarid qilgan holda, xarid qilingan
										qurilmalardan bir yoki bir nechtasida oylik to’lovlarda
										kechikishlar bo’lsa, barcha qurilmalarga ogohlantirish
										jo’natiladi va masofadan qulflanadi. Qurilma masofadan
										qulflanganida qurilma ichidagi barcha ma’lumotlar o’chib
										ketishi mumkinligi haqida sotuvchi tomonidan ogohlantirildim
										va shunga roziman____________(imzo)
									</p>

									<p>
										<span className="ml-8">Men</span> shaxsiy ma'lumotlarim
										qayta ishlanishiga, shuningdek qarzdorlik yoki qarzni
										to'lamaslik holatida shaxsiy identifikatsion raqamim
										bo'yicha topilgan barcha mavjud va yangi ochiladigan to'lov
										kartalaridan (Uzcard/Humo va Kobeyj kartalari) qarz
										mablag'larini echib olinishiga o'z roziligimni
										beradi________(imzo).
									</p>
									<p>
										<span className="ml-8">Qurilmaga</span> tegishli kafolat
										taloni bilan to’liq tanishib chiqdim va shu kafolat
										shartlari asosida xarid qilishga roziman. ____________(imzo)
									</p>
									<p>
										<span className="ml-8">Qurilma</span> qutisi va xujjatlari
										sotuvchida kafolat sifatida qarzdorlik to’liq to’languniga
										qadar saqlanadi. Qurilma uchun qarzdorlik to’liq to’lab
										bo’linganidan so’ng, qurilma qutisi va xujjatlari oxirgi
										to’lov qilinganidan so’ng 5 ish kuni ichida xarid amalga
										oshirilgan do’konga yoki xaridor bilan kelishilgan holda
										boshqa filialga yetkazib beriladi. Agar 5 ish kuni ichida
										kelishilgan do’konga yetkazib berilmasa, sotuvchi xaridorga
										qutini yetkazib berishga majbur. Sotuvchi texnika uchun
										qarzlar to’liq to’langan kundan boshlab 1 oy mobaynida
										qutini saqlashni zimmasiga oladi va 1 oydan keyin saqlab
										berishga majbur emas. O’z vaqtida olib ketilmagan texnika
										qutilari tashlab yuborilishi haqida sotuvchi tomonidan
										ogohlantirildim. ____________(imzo)
									</p>
								</div>
							)}

							{isTablet && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Men</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										sotuvchi Abitov Murod Mansurovichdan Planshet turi:{' '}
										<span className="font-bold">{fullItemName}</span>
										IMEI kodi: <span className="font-bold">{imei}</span>,{' '}
										bo’lgan planshetni pulini mudattli to’lov sharti bilan sotib
										oldim. Planshetni umumiy narxi{' '}
										<span className="font-bold">{docTotal}</span>
										dollari miqdorida bolib shundan{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										AQSH dollari miqdoridagi pulni SOTUV KURSI bo’yicha{' '}
										<span className="font-bold">{sotuvKursi}</span>
										so’mda oldindan to’ladim. Qolgan {'  '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										AQSH dollari miqdoridagi pulni{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}
											oy
										</span>{' '}
										davomida har oyning{' '}
										<span className="font-bold">{paymentDate}</span>
										-sanasida <span className="font-bold">
											{oylikTolov}
										</span>{' '}
										AQSH dollari miqdoridagi pulni tijorat banklari sotuv kursi
										bo’yicha so’mda sotuvchi aytgan joyga va o’z vaqtidan
										kechiktirmay to’lab borilishini o’zim ta’minlayman.
										__________(imzo)
									</p>
									<p>
										<span className="ml-8"> Agar </span>
										men oylik to‘lovlarni o‘z vaqtida va to‘liq miqdorda to‘lay
										olmasam, planshetni sotuvchining birinchi talabidayoq
										bus-butun holda, hech qanday buzilishlarsiz o‘zim qaytarib
										beraman. Planshetni sotuvchiga qaytarish qarzdorlik to‘liq
										qoplanadi degani emas. Planshet sotuvchiga qaytarilgan
										vaqtida uning o‘sha vaqtdagi holatiga qarab baholanadi va
										sotiladi. Shunda ham tilxatda ko‘rsatilgan qarzim to‘liq
										qoplanmasa, qolgan qarzdorlikni o‘z vaqtidan kechiktirmay
										to‘liq to‘lab berishga majburman. Oylik to‘lovlar muddatidan
										oldin to‘liq to‘langan taqdirda yoki muddatidan
										kechiktirilgan taqdirda ham tilxatda kelishilgan umumiy narx
										miqdori o‘zgarmasligi haqida ogohlantirildim va shunga
										roziman. ____________(imzo)
									</p>
									<p>
										<span className="ml-8">Ushbu </span>
										tilxat bilan men muddatli to‘lov asosida sotib olayotgan
										qurilmaga sotuvchi tomonidan qulflash tizimi o‘rnatilishiga
										roziligimni bildiraman. O‘rnatilgan tizim orqali qurilmaga
										va berilgan telefon raqamlariga oylik to‘lovlar va
										qarzdorliklar haqidagi SMS xabarlar jo‘natilishiga roziman.
										Agar men oylik to‘lovni belgilangan muddatdan 5 ish kuni
										mobaynida kechiktirsam yoki uni to‘liq to‘lamasam sotuvchi
										ushbu qurilmani masofadan qulflashiga roziman. Bir xaridor
										bir nechta qurilma xarid qilgan holda, xarid qilingan
										qurilmalardan bir yoki bir nechtasida oylik to‘lovlarda
										kechikishlar bo‘lsa, barcha qurilmalarga ogohlantirish
										jo‘natiladi va masofadan qulflanadi. Qurilma masofadan
										qulflanganida qurilma ichidagi barcha ma’lumotlar o‘chib
										ketishi mumkinligi haqida sotuvchi tomonidan ogohlantirildim
										va shunga roziman. ____________(imzo)
									</p>

									<p>
										<span className="ml-8">Men</span> shaxsiy ma’lumotlarim
										qayta ishlanishiga, shuningdek qarzdorlik yoki qarzni
										to‘lamaslik holatida shaxsiy identifikatsion raqamim
										bo‘yicha topilgan barcha mavjud va yangi ochiladigan to‘lov
										kartalaridan (Uzcard/Humo va Kobeyj kartalari) qarz
										mablag‘larini echib olinishiga o‘z roziligimni bildiraman.
										__________(imzo)
									</p>
									<p>
										<span className="ml-8">Qurilmaga</span> tegishli kafolat
										taloni bilan to‘liq tanishib chiqdim va shu kafolat
										shartlari asosida xarid qilishga roziman. ____________(imzo)
									</p>
									<p>
										<span className="ml-8">Qurilma</span> Qurilma qutisi va
										hujjatlari sotuvchida kafolat sifatida qarzdorlik to‘liq
										to‘languniga qadar saqlanadi. Qurilma uchun qarzdorlik
										to‘liq to‘lab bo‘linganidan so‘ng, qurilma qutisi va
										hujjatlari oxirgi to‘lov qilinganidan so‘ng 5 ish kuni
										ichida xarid amalga oshirilgan do‘konga yoki xaridor bilan
										kelishilgan holda boshqa filialga yetkazib beriladi. Agar 5
										ish kuni ichida kelishilgan do‘konga yetkazib berilmasa,
										sotuvchi xaridorga qutini yetkazib berishga majbur. Sotuvchi
										texnika uchun qarzlar to‘liq to‘langan kundan boshlab 1 oy
										mobaynida qutini saqlashni zimmasiga oladi va 1 oydan keyin
										saqlab berishga majbur emas. O‘z vaqtida olib ketilmagan
										texnika qutilari tashlab yuborilishi haqida sotuvchi
										tomonidan ogohlantirildim. ____________(imzo)
									</p>
								</div>
							)}

							{isNoutbuk && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Men</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										sotuvchi Abitov Murod Mansurovichdan Qurilmaning turi:{' '}
										<span className="font-bold">{fullItemName}</span>
										Seriya raqami: <span className="font-bold">{imei}</span>,
										bo’lgan qurilmani pulini mudattli to’lov sharti bilan sotib
										oldim. Qurilmaning umumiy narxi{' '}
										<span className="font-bold">{docTotal}</span>
										dollari miqdorida bolib shundan{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										AQSH dollari miqdoridagi pulni SOTUV KURSI bo’yicha{' '}
										<span className="font-bold">{sotuvKursi}</span>
										so’mda oldindan to’ladim. Qolgan {'  '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										AQSH dollari miqdoridagi pulni{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}
											oy
										</span>{' '}
										davomida har oyning{' '}
										<span className="font-bold">{paymentDate}</span>
										-sanasida <span className="font-bold">
											{oylikTolov}
										</span>{' '}
										AQSH dollari miqdoridagi pulni tijorat banklari sotuv kursi
										bo’yicha so’mda sotuvchi aytgan joyga va o’z vaqtidan
										kechiktirmay to’lab borilishini o’zim ta’minlayman.
										__________(imzo)
									</p>
									<p>
										<span className="ml-8"> Agar </span>
										men oylik to‘lovlarni o‘z vaqtida va to‘liq miqdorda to‘lay
										olmasam, qurilmani sotuvchining birinchi talabidayoq
										bus-butun holda, hech qanday buzilishlarsiz o‘zim qaytarib
										beraman. Qurilmani sotuvchiga qaytarish qarzdorlik to‘liq
										qoplanadi degani emas. Qurilma sotuvchiga qaytarilgan
										vaqtida uning o‘sha vaqtdagi holatiga qarab baholanadi va
										sotiladi. Shunda ham tilxatda ko‘rsatilgan qarzim to‘liq
										qoplanmasa, qolgan qarzdorlikni o‘z vaqtidan kechiktirmay
										to‘liq to‘lab berishga majburman. Oylik to‘lovlar muddatidan
										oldin to‘liq to‘langan taqdirda yoki muddatidan
										kechiktirilgan taqdirda ham tilxatda kelishilgan umumiy narx
										miqdori o‘zgarmasligi haqida ogohlantirildim va shunga
										roziman.____________(imzo)
									</p>
									<p>
										<span className="ml-8">Ushbu </span>
										tilxat bilan men bergan telefon raqamlarimga oylik to‘lovlar
										va qarzdorliklar haqidagi SMS xabarlar yuborilishiga
										roziman. ____________(imzo)
									</p>

									<p>
										<span className="ml-8">Men</span> shaxsiy ma’lumotlarim
										qayta ishlanishiga, shuningdek qarzdorlik yoki qarzni
										to‘lamaslik holatida shaxsiy identifikatsion raqamim
										bo‘yicha topilgan barcha mavjud va yangi ochiladigan to‘lov
										kartalaridan (Uzcard/Humo va Kobeyj kartalari) qarz
										mablag‘larini echib olishga rozilik
										bildiraman.____________(imzo)
									</p>
									<p>
										<span className="ml-8">Qurilmaga</span> tegishli kafolat
										taloni bilan to‘liq tanishib chiqdim va shu kafolat
										shartlari asosida xarid qilishga roziman.____________(imzo)
									</p>
									<p>
										<span className="ml-8">Qurilma</span> qutisi va hujjatlari
										sotuvchida kafolat sifatida qarzdorlik to‘liq to‘languniga
										qadar saqlanadi. Qarzdorlik to‘liq to‘langandan so‘ng, quti
										va hujjatlar 5 ish kuni ichida xarid qilingan do‘konga yoki
										mijoz bilan kelishilgan filialga topshiriladi. Agar 5 ish
										kuni ichida topshirilmasa, sotuvchi xaridorga qutini
										yetkazishga majbur. Qarz to‘liq to‘langan kundan boshlab,
										quti 1 oy davomida saqlanadi. Shu muddat ichida olib
										ketilmasa, sotuvchi qutini saqlash majburiyatidan ozod
										bo‘ladi.____________(imzo)
									</p>
								</div>
							)}
							{isTechnique && (
								<div className="contract-content">
									<p>
										<span className="ml-8">Men</span>{' '}
										<span className="font-bold">{userData.CardName}</span>{' '}
										sotuvchi Abitov Murod Mansurovichdan{' '}
										<span className="font-bold">{fullItemName}</span>
										IMEI kodi: <span className="font-bold">{imei}</span>,{' '}
										bo’lgan texnikani pulini mudattli to’lov sharti bilan sotib
										oldim. Texnikaning umumiy narxi{' '}
										<span className="font-bold">{docTotal}</span>
										dollari miqdorida bolib shundan{' '}
										<span className="font-bold">
											{hasFirstPayment ? vznos : 0}{' '}
										</span>
										AQSH dollari miqdoridagi pulni SOTUV KURSI bo’yicha{' '}
										<span className="font-bold">{sotuvKursi}</span>
										so’mda oldindan to’ladim. Qolgan {'  '}
										<span className="font-bold">
											{hasFirstPayment
												? debtAmount
												: paymentDates.reduce(
														(sum, item) => sum + item.InsTotal,
														0,
													)}
										</span>{' '}
										AQSH dollari miqdoridagi pulni{' '}
										<span className="font-bold">
											{hasFirstPayment
												? installmentMonth
												: installmentMonth + 1}{' '}
											oy
										</span>{' '}
										davomida har oyning{' '}
										<span className="font-bold">{paymentDate}</span>
										-sanasida <span className="font-bold">
											{oylikTolov}
										</span>{' '}
										AQSH dollari miqdoridagi pulni tijorat banklari sotuv kursi
										bo’yicha so’mda sotuvchi aytgan joyga va o’z vaqtidan
										kechiktirmay to’lab borilishini o’zim ta’minlayman.
										__________(imzo)
									</p>
									<p>
										<span className="ml-8"> Agar </span>
										men oylik to'lovlarni o'z vaqtida va to'liq miqdorda to'lay
										olmasam, texnikani sotuvchining birinchi talabidayoq
										bus-butun holda, hech qanday buzilishlarsiz o’zim qaytarib
										beraman. Texnikani sotuvchiga qaytarish qarzdorlik to’liq
										qoplanadi degani emas. Texnika sotuvchiga qaytarilgan
										vaqtida uning o’sha vaqtdagi holatiga qarab baholanadi va
										sotiladi. Shunda ham tilxatda ko’rsatilgan qarzim to’liq
										qoplanmasa, qolgan qarzdorlikni o’z vaqtidan kechiktirmay
										to’liq to’lab berishga majburman. Oylik to’lovlar muddatidan
										oldin to’liq to’langan taqdirda yoki muddatidan
										kechiktirilgan taqdirda ham tilxatda kelishilgan umumiy narx
										miqdori o’zgarmasligi haqida ogohlantirildim va shunga
										roziman. ____________(imzo)
									</p>
									<p>
										<span className="ml-8">Ushbu </span>
										tilxat bilan men muddatli to’lov asosida sotib olayotgan
										texnikaga sotuvchi tomonidan qulflash tizimi o’rnatilishiga
										roziligimni bildiraman (Qulflash tizimi qo’yishni imkoni
										bo’lsa). O’rnatilgan tizim orqali texnikaga va berilgan
										telefon raqamlariga oylik to’lovlar va qarzdorliklar
										haqidagi sms xabarlar jo’natilishiga roziman. Agar men oylik
										to'lovni belgilangan muddatdan 5 ish kuni mobaynida
										kechiktirsam yoki uni to'liq to'lamasam sotuvchi ushbu
										texnikani masofadan qulflashiga roziman. Bir xaridor bir
										nechta texnika xarid qilgan holda, xarid qilingan
										texnikalardan bir yoki bir nechtasida oylik to’lovlarda
										kechikishlar bo’lsa, barcha texnikalarga ogohlantirish
										jo’natiladi va masofadan qulflanadi. Texnika masofadan
										qulflanganida texnika ichidagi barcha ma’lumotlar o’chib
										ketishi mumkinligi haqida sotuvchi tomonidan ogohlantirildim
										va shunga roziman____________(imzo)
									</p>

									<p>
										<span className="ml-8">Men</span> haxsiy ma'lumotlarim qayta
										ishlanishiga, shuningdek qarzdorlik yoki qarzni to'lamaslik
										holatida shaxsiy identifikatsion raqamim bo'yicha topilgan
										barcha mavjud va yangi ochiladigan to'lov kartalaridan
										(Uzcard/Humo va Kobeyj kartalari) qarz mablag'larini echib
										olinishiga o'z roziligimni beradi________(imzo).
									</p>
									<p>
										<span className="ml-8">Texnikaga</span> tegishli kafolat
										taloni bilan to’liq tanishib chiqdim va shu kafolat
										shartlari asosida xarid qilishga roziman. ____________(imzo)
									</p>
									<p>
										<span className="ml-8">Texnika</span> qutisi va xujjatlari
										sotuvchida kafolat sifatida qarzdorlik to’liq to’languniga
										qadar saqlanadi. Texnika uchun qarzdorlik to’liq to’lab
										bo’linganidan so’ng, texnika qutisi va xujjatlari oxirgi
										to’lov qilinganidan so’ng 5 ish kuni ichida xarid amalga
										oshirilgan do’konga yoki xaridor bilan kelishilgan holda
										boshqa filialga yetkazib beriladi. Agar 5 ish kuni ichida
										kelishilgan do’konga yetkazib berilmasa, sotuvchi xaridorga
										qutini yetkazib berishga majbur. Sotuvchi texnika uchun
										qarzlar to’liq to’langan kundan boshlab 1 oy mobaynida
										qutini saqlashni zimmasiga oladi va 1 oydan keyin saqlab
										berishga majbur emas. O’z vaqtida olib ketilmagan texnika
										qutilari tashlab yuborilishi haqida sotuvchi tomonidan
										ogohlantirildim. ____________(imzo)
									</p>
								</div>
							)}

							<br />
							<br />
							<br />
							<br />
							<div>
								<h1 className="text-center mt-10 mb-3">
									<b>ESLATMA</b>
								</h1>
								{isMobilePhone && (
									<div className="ml-8">
										{' '}
										<p>
											<b>1. </b>
											Xaridor qurilmani do'kondan chiqib ketishidan avval to'liq
											tekshirib olishga majburdir. Biror jismoniy nuqsoni
											(masalan ekran yoki korpusdagi qirilish, dog’) bor bo’lsa,
											do’kondan chiqmasdan turib sotuvchiga xabar berilishi
											kerak. Qurilma do’kondan olib chiqib ketilganidan keyin
											yuqoridagiga o’xshash biror jismoniy nuqson bilan qaytarib
											olib kelinsa, bunga sotuvchi javobgar emas.
										</p>
										<p>
											<b>2. </b>
											Telefon sotib olinganidan keyin xaridorga yoqmay
											qolganligi uchun telefonni qaytarib olishga yoki
											boshqasiga almashtirib berishga sotuvchi majbur emas.
											Mijoz tilxatni imzolanganidan keyin muddat va narx
											o’zgartirilmaydi.
										</p>
										<div>
											<p>
												<b>3. </b>
												Telefonga xaridor tarafdan jismoniy zararlar
												yetkazilishi va undan noto’g’ri foydalanishi,
												o’zboshimchalik bilan servis ustalaridan boshqa ustalar
												ta’mirlagani sababli telefon buzilsa (bu holatda kafolat
												amal qilmaydi) ham, telefon o'g'irlab ketilsa va yoqotib
												qo'yilsa ham xaridor tilxatda ko’rsatilgan muddatda
												belgilangan to’lovlarni o’z vaqtida, to’liq to’lashga
												majbur.
											</p>
										</div>
										<p>
											<b>4. </b>
											Sotuvchi tomonidan mobil telefonlarga o'rnatilgan iCloud,
											Samsung Account yoki MI Account kabi tizimlar xaridor
											tomonidan buzishga harakat qilinsa yoki biror kirgazilgan
											ma’lmot o’zgartirilsa sotuvchi bu tizimni mobil telefondan
											chiqarib berish javobgarligidan ozod bo’ladi. Bunday
											holatda xaridor o’zi javobgar bo’ladi.
										</p>
									</div>
								)}
								{isTablet && (
									<div className="ml-8">
										{' '}
										<p>
											<b>1. </b>
											Xaridor qurilmani do‘kondan chiqib ketishidan avval to‘liq
											tekshirib olishga majburdir. Biror jismoniy nuqsoni
											(masalan ekran yoki korpusdagi qirilish, dog‘) bor bo‘lsa,
											do‘kondan chiqmasdan turib sotuvchiga xabar berilishi
											kerak. Qurilma do‘kondan olib chiqib ketilganidan keyin
											yuqoridagiga o‘xshash biror jismoniy nuqson bilan qaytarib
											olib kelinsa, bunga sotuvchi javobgar emas.
										</p>
										<p>
											<b>2. </b>
											Planshet sotib olinganidan keyin xaridorga yoqmay
											qolganligi uchun planshetni qaytarib olishga yoki
											boshqasiga almashtirib berishga sotuvchi majbur emas.
											Mijoz tilxatni imzolaganidan keyin muddat va narx
											o‘zgartirilmaydi.
										</p>
										<div className="mt-5">
											<p>
												<b>3. </b>
												Planshetga xaridor tarafdan jismoniy zararlar
												yetkazilishi va undan noto‘g‘ri foydalanilishi,
												o‘zboshimchalik bilan servis ustalaridan boshqa ustalar
												ta’mirlagani sababli planshet buzilsa (bu holatda
												kafolat amal qilmaydi) ham, planshet o‘g‘irlab ketilsa
												va yo‘qotib qo‘yilsa ham xaridor tilxatda ko‘rsatilgan
												muddatda belgilangan to‘lovlarni o‘z vaqtida, to‘liq
												to‘lashga majbur.
											</p>
										</div>
										<p>
											<b>4. </b>
											Sotuvchi tomonidan planshetlarga o‘rnatilgan iCloud,
											Samsung Account yoki MI Account kabi tizimlar xaridor
											tomonidan buzishga harakat qilinsa yoki biror kirgazilgan
											ma’lumot o‘zgartirilsa, sotuvchi bu tizimni planshetdan
											chiqarib berish javobgarligidan ozod bo‘ladi. Bunday
											holatda xaridor o‘zi javobgar bo‘ladi.
										</p>
										<p>
											<b>5. </b>
											Ushbu tilxatning barcha shartlarini biror fors-major
											holati bo‘lgan taqdirda ham, karantin sababli ham
											bajarishga roziman. Bu holatlar mening oylik to‘lovlarimni
											o‘z vaqtida to‘lashimga to‘sqinlik qilmasligini to‘liq
											kafolatlayman.
										</p>
									</div>
								)}
								{isNoutbuk && (
									<div className="ml-8">
										{' '}
										<p>
											<b>1. </b>
											Xaridor qurilmani do‘kondan olib chiqishdan oldin to‘liq
											tekshirishi kerak. Ekran yoki korpusda jismoniy shikastlar
											bo‘lsa, do‘kondan chiqmasdan sotuvchiga xabar berilishi
											lozim. Do‘kondan olib chiqqandan keyin aniqlangan jismoniy
											nuqsonlar uchun sotuvchi javobgar emas.
										</p>
										<p>
											<b>2. </b>Qurilma xarid qilingach, xaridorga u yoqmagan
											taqdirda, uni qaytarish yoki almashtirish sotuvchining
											majburiyati emas. Tilxat imzolangach, shartnoma shartlari
											o‘zgartirilmaydi.
										</p>
										<div>
											<p>
												<b>3. </b>
												Qurilmaga xaridor tomonidan yetkazilgan jismoniy
												zararlar, noto‘g‘ri foydalanish, notavsiyaviy ustalarga
												topshirish, o‘g‘irlik yoki yo‘qotish holatlarida ham
												xaridor barcha qarzdorlikni o‘z vaqtida to‘liq to‘lashi
												shart.
											</p>
										</div>
										<p>
											<b>4. </b>
											Agar xaridor qurilmaga o‘zboshimchalik bilan parol yoki
											blok tizimlarini o‘rnatgan bo‘lsa va bu tizimlar
											natijasida muammolar yuzaga kelsa, u holda sotuvchi bu
											holat uchun javobgar emas.
										</p>
										<p>
											<span className="ml-5">Ushbu</span> tilxatning barcha
											shartlarini biror fors-major holati bo’lgan taqdirda ham,
											karantin sababli ham bajarishga roziman. Bu holatlar
											mening oylik to’lovlarimni o’z vaqtida to’lashimga
											to’sqinlik qilmasligini to’liq skafolatlayman.
										</p>
									</div>
								)}
								{isTechnique && (
									<div className="ml-8">
										{' '}
										<p>
											<b>1.</b>
											Xaridor texnikani do'kondan chiqib ketishidan avval to'liq
											tekshirib olishga majburdir. Biror jismoniy nuqsoni
											(masalan ekran yoki korpusdagi qirilish, dog’) bor bo’lsa,
											do’kondan chiqmasdan turib sotuvchiga xabar berilishi
											kerak. Texnika do’kondan olib chiqib ketilganidan keyin
											yuqoridagiga o’xshash biror jismoniy nuqson bilan qaytarib
											olib kelinsa, bunga sotuvchi javobgar emas.
										</p>
										<p>
											<b>2.</b>.Texnika sotib olinganidan keyin xaridorga yoqmay
											qolganligi uchun texnikani qaytarib olishga yoki
											boshqasiga almashtirib berishga sotuvchi majbur emas.
											Mijoz tilxatni imzolanganidan keyin muddat va narx
											o’zgartirilmaydi.
										</p>
										<div>
											<p>
												<b>3.</b>
												Texnikaga xaridor tarafdan jismoniy zararlar
												yetkazilishi va undan noto’g’ri foydalanishi,
												o’zboshimchalik bilan servis ustalaridan boshqa ustalar
												ta’mirlagani sababli texnika buzilsa (bu holatda kafolat
												amal qilmaydi) ham, Texnika o'g'irlab ketilsa va yoqotib
												qo'yilsa ham xaridor tilxatda ko’rsatilgan muddatda
												belgilangan to’lovlarni o’z vaqtida, to’liq to’lashga
												majbur.
											</p>
										</div>
										<p>
											<span className="ml-5">Ushbu</span> tilxatning barcha
											shartlarini biror fors-major holati bo’lgan taqdirda ham,
											karantin sababli ham bajarishga roziman. Bu holatlar
											mening oylik to’lovlarimni o’z vaqtida to’lashimga
											to’sqinlik qilmasligini to’liq kafolatlayman.
										</p>
									</div>
								)}

								<div className="flex w-full mt-10 font-bold">
									<hr className="w-full border-t font-bold border-black" />
								</div>

								<div className="flex w-full mt-10 font-bold">
									<hr className="w-full border-t font-bold border-black" />
								</div>
							</div>

							<div className="ml-[5px] mt-10 flex items-center justify-between">
								<div className="flex flex-col gap-3">
									<p>
										<b>Xaridor tel raqami:</b>
									</p>
									<div>
										{Array.isArray(telephoneNum) ? (
											telephoneNum.slice(0, 4).map((num, index) => (
												<p key={index}>
													<b>
														{index + 1}.{' '}
														{formatPhoneNumber(formatPhoneNumber4(num))}
													</b>
												</p>
											))
										) : (
											<p>
												<b>1. {formatPhoneNumber(telephoneNum)}</b>
											</p>
										)}
									</div>
								</div>

								<div>
									<img src={logo} className="w-[200px]" alt="logo" />
								</div>

								<div className="flex flex-col gap-2">
									<p>
										<b>
											Sana:{' '}
											{paymentDates
												? moment(paymentDates[0]?.DocDate).format('DD.MM.YYYY')
												: '________'}
										</b>
									</p>

									<p>
										<b> Imzo: _____________</b>
									</p>
								</div>
							</div>
							<div className="flex flex-col gap-2">
								<p className="text-center font-extrabold text-base px-3">
									KAFOLAT TALONI
								</p>

								<p>
									<b>
										{isTechnique ? 'TEXNIKA' : 'QURILMA'} TURI:{' '}
										{item?.U_Group
											? item?.U_Group
											: '__________________________________'}
									</b>
								</p>

								<p>
									<b>
										MODEL:{'    '}
										{item?.ItemName
											? item?.ItemName
											: '__________________________________'}
									</b>
								</p>
								<p>
									<b>
										{isTechnique ? 'TEXNIKA' : 'QURILMA'} HOLATI:{'    '}
										{item?.U_Condition
											? item?.U_Condition
											: '__________________________________'}
									</b>
								</p>
								<p>
									<b>
										SERIA RAQAMI:{'    '}
										{invoice?.DocumentLines[0]?.SerialNumbers[0]
											?.InternalSerialNumber
											? invoice.DocumentLines[0].SerialNumbers[0]
													.InternalSerialNumber
											: '_______________'}
									</b>
								</p>
								<p>
									<b>
										XARID QILINGAN SANA:{'    '}
										{paymentDates
											? moment(paymentDates[0]?.DocDate).format('DD.MM.YYYY')
											: '________'}
									</b>
								</p>

								<p>
									<b>
										DO’KON TELEFON RAQAMI:{'    '}
										{invoice?.DocumentLines[0]?.WarehouseCode
											? whsData?.find(
													(whs) =>
														whs.WarehouseCode ===
														invoice.DocumentLines[0].WarehouseCode,
												)?.U_Branch_Number
											: '_______________'}
									</b>
								</p>
								<div className="flex w-full flex-col px-6">
									<h1 className="text-center">
										<b>
											KAFOLAT MAJBURIYATLARI VA BEPUL XIZMAT KO’RSATISH
											SHARTLARI
										</b>
									</h1>
									{isMobilePhone && (
										<p>
											<b>1.</b> Kafolat bo‘yicha ta’mirlatish uchun, avvalo, shu
											qurilmangiz CredoMobileUz do’konlaridan biridan xarid
											qilingan bo‘lishi shart. Buning dalili sifatida
											siz qurilmaning qutisi va xujjatlarini, shuningdek, uni
											sotib olgan paytingizda do‘kondan olingan kafolat
											talonini taqdim etishingiz lozim. Boshqa do’konlardan
											olingan texnikalar uchun CredoMobileUz kafolat bermaydi.
										</p>
									)}

									{isTablet && (
										<p>
											<b>1.</b> Kafolat bo‘yicha ta’mirlatish uchun, avvalo, shu
											qurilmangiz CredoMobileUz do‘konlaridan biridan xarid
											qilingan bo‘lishi shart. Buning dalili sifatida siz
											Qurilmaning qutisi va hujjatlarini, shuningdek, uni sotib
											olgan paytingizda do‘kondan olingan kafolat talonini
											taqdim etishingiz lozim. Boshqa do’konlardan olingan
											texnikalar uchun CredoMobileUz kafolat bermaydi.
										</p>
									)}
									{isNoutbuk && (
										<p>
											<b>1.</b> Kafolat bo‘yicha ta’mirlatish uchun, avvalo, shu
											qurilmangiz CredoMobileUz do’konlaridan biridan xarid
											qilingan bo‘lishi shart. Buning dalili sifatida
											siz qurilmaning qutisi va xujjatlarini, shuningdek, uni
											sotib olgan paytingizda do‘kondan olingan kafolat
											talonini taqdim etishingiz lozim. Boshqa do’konlardan
											olingan texnikalar uchun CredoMobileUz kafolat bermaydi.
										</p>
									)}
									{isTechnique && (
										<p>
											<b>1.</b> Kafolat bo‘yicha ta’mirlatish uchun, avvalo, shu
											texnikangiz CredoMobileUz do’konlaridan biridan xarid
											qilingan bo‘lishi shart. Buning dalili sifatida
											siz texnikaning qutisi va xujjatlarini, shuningdek, uni
											sotib olgan paytingizda do‘kondan olingan kafolat
											talonini taqdim etishingiz lozim. Boshqa do’konlardan
											olingan texnikalar uchun CredoMobileUz kafolat bermaydi.
										</p>
									)}
								</div>
							</div>

							<div className="talon-section bg-white px-6 relative">
								{/* First logo */}
								<img
									src={logo}
									alt="background logo"
									style={{
										position: 'absolute',
										top: '15%',
										left: '10%',
										width: '600px',
										height: '170px',
										transform: 'rotate(-380deg)',
										opacity: 0.5,
										zIndex: 0,
									}}
								/>

								{/* Second logo */}
								<img
									src={logo}
									alt="background logo"
									style={{
										position: 'absolute',
										top: '50%',
										left: '10%',
										width: '600px',
										height: '170px',
										transform: 'rotate(-380deg)',
										opacity: 0.5,
										zIndex: 0,
									}}
								/>

								{/* Add a semi-transparent overlay to make the watermark effect more subtle */}
								<div
									className="absolute inset-0"
									style={{
										zIndex: 1,
									}}
								></div>

								{/* Existing Content with higher z-index to stay above the overlay */}
								<div className="relative z-10">
									{isMobilePhone && (
										<div>
											<p>
												<b>2.</b> Qurilmaning ichi ochilmagan bo‘lishi shart.
												Buni bilish unchalik qiyin emas – har bir qurilmaning
												hali ochilmaganligini bildiruvchi plombalari mavjud.
											</p>
											<div>
												<p>
													<b>3.</b> Agarda smartfon yoki boshqa
													qurilmangizning tashqi nuqsoni bo‘lsa, unga servis
													xizmati ko‘rsatishmaydi. Deylik, telefoningiz
													ekranining bir burchagida ozgina qirilgan yoki pachoq
													bo’lgan iz bor. Agarda shu holida uning boshqa bir
													qismi, masalan, kamerasi yaxshi ishlamayotgan bo‘lsa
													ham, CredoMobile unga kafolat xizmati ko‘rsatishmaydi.
													Sababi oddiy – ekrandagi qirilish smartfonni siz yerga
													tushirib yuborganingiz yoki qattiqroq biror narsaga
													urib olganingizni anglatadi. O‘z-o‘zidan ma’lumki,
													kamerasi ham o‘shanda buzilib qolgan – unga servis
													xizmati ko‘rsatishni esa ishlab chiqaruvchi o‘z
													zimmasiga olmaydi.
												</p>
											</div>
											<p>
												<b>4.</b> Qurilmaning dasturiy ta’minotiga nolegal
												o‘zgartirish kiritilmagan bo‘lishi lozim.
												Masalan, smartfonga root huquqi olingan bo‘lsa, ishlab
												chiqaruvchi unga servis xizmati ko‘rsatishni rad etishga
												haqli. Zero, shu kabi o‘zgartirishlar qurilmaning ayrim
												qismlari yoki operatsion tizimi ishdan chiqishiga olib
												keladi va bunday hollar uchun CredoMobile mas’ul
												bo‘lmaydi. Beta versiyadagi operatsion tizimlar
												o’rnatilgan qurilmaga ham kafolat berilmaydi.
											</p>
											<p>
												<b>5.</b> Xarid qilingan telefon uchun sotib olingan
												kundan boshlab 3 kun muddat ichida biror texnik
												nuqsonlar (xaridorning ta’sirisiz) kelib chiqqan
												taqdirda boshqa xuddi shunday telefonga almashtirib
												berish yo’li bilan kafolat beriladi. Xarid qilinganiga 3
												kundan ortiq vaqt o’tib CredoMobile ga nuqson bilan olib
												borilgan hech bir qurilmaning o‘zi yangisiga(boshqasiga)
												almashtirib berilmaydi, balki uning nuqsonli qismi
												(kamera, ekran, USB-port yoki boshqa joyi) yangisiga
												almashtiriladi, xolos. Bepul ta’mirlash xizmati xarid
												kunidan boshlab 100 kun ichida kelib chiqgan nuqsonlar
												uchun amal qiladi. Xarid qilinganiga 100 kundan ortiq
												vaqt o’tgan hech bir qurilmada kelib chiqgan nuqsonlar
												uchun CredoMobile kafolat va bepul serviz xizmatini
												zimmasiga olmaydi. Bunday holatda xaridor pullik
												servislarga murojaat qilishga haqli.
											</p>

											<p>
												<b>6.</b> Kafolat bo‘yicha servis xizmati ko‘rsatilishi
												uchun, siz nuqsonli, ammo yuqoridagi talablarga mos
												keluvchi qurilmangizni CredoMobile da qoldirib
												ketishingiz kerak bo‘ladi. Ya’ni, uni shu zahotiyoq
												tuzatib yoki ishlamayotgan qismini almashtirib bera
												olinmaydi. Qancha muddatga qoldirish kerakligi esa
												Qurilmaning nuqsoni qay darajada ekanligidan kelib
												chiqib, ma’lum qilinadi.
											</p>
											<p>
												<b>7.</b> Sotilgan har bir mobil telefonning jismoniy
												sim karta slotlarining IMEI kodlari sotuvchi tomonidan
												UZIMEI ro’yhatidan o’tkazib beriladi. Jismoniy sim karta
												sloti bo’lmagan telefonlarning faqat bitta IMEI kodi
												UZIMEI dan ro’yhatdan o’tkazib beriladi. Jismoniy
												bo'lmagan ikkinchi sim karta sloti uchun IMEI kodlarini
												ro’yhatdan o’tkazishni sotuvchi o’z majburiyatiga
												olmaydi. Bunday IMEI kodlarni xaridor xohishiga ko’ra
												pullik xizmat ko’rsatuvchilardan o’zi ro’yhatdan
												o’tkazib olishga haqli.
											</p>
										</div>
									)}

									{isTablet && (
										<div>
											<p>
												<b>2.</b> Qurilmaning ichi ochilmagan bo‘lishi shart.
												Buni bilish unchalik qiyin emas – har bir qurilmaning
												hali ochilmaganligini bildiruvchi plombalari mavjud.
											</p>
											<div>
												<p>
													<b>3.</b> Agarda qurilmaning tashqi nuqsoni bo‘lsa,
													unga servis xizmati ko‘rsatishmaydi. Deylik,
													planshetingiz ekranining bir burchagida ozgina
													qirilgan yoki pachoq bo‘lgan iz bor. Agarda shu
													holatda uning boshqa bir qismi, masalan, kamerasi
													yaxshi ishlamayotgan bo‘lsa ham, CredoMobile unga
													kafolat xizmati ko‘rsatishmaydi. Sababi oddiy –
													ekrandagi qirilish planshetni siz yerga tushirib
													yuborganingiz yoki qattiqroq biror narsaga urib
													olganingizni anglatadi. O‘z-o‘zidan ma’lumki, kamerasi
													ham o‘shanda buzilib qolgan – unga servis xizmati
													ko‘rsatishni esa ishlab chiqaruvchi o‘z zimmasiga
													olmaydi.
												</p>
											</div>
											<p>
												<b>4.</b> Qurilmaning dasturiy ta’minotiga nolegal
												o‘zgartirish kiritilmagan bo‘lishi lozim. Masalan,
												planshetga root huquqi olingan bo‘lsa, ishlab
												chiqaruvchi unga servis xizmati ko‘rsatishni rad etishga
												haqli. Zero, shu kabi o‘zgartirishlar qurilmaning ayrim
												qismlari yoki operatsion tizimi ishdan chiqishiga olib
												keladi va bunday hollar uchun CredoMobile mas’ul
												bo‘lmaydi. Beta versiyadagi operatsion tizimlar
												o‘rnatilgan qurilmaga ham kafolat berilmaydi.
											</p>
											<p>
												<b>5.</b> Xarid qilingan planshet uchun sotib olingan
												kundan boshlab 3 kun muddat ichida biror texnik
												nuqsonlar (xaridorning ta’sirisiz) kelib chiqqan
												taqdirda boshqa xuddi shunday planshetga almashtirib
												berish yo‘li bilan kafolat beriladi. Xarid qilinganiga 3
												kundan ortiq vaqt o‘tib CredoMobile ga nuqson bilan olib
												borilgan hech bir qurilmaning o‘zi yangisiga
												(boshqasiga) almashtirib berilmaydi, balki uning
												nuqsonli qismi (kamera, ekran, USB-port yoki boshqa
												joyi) yangisiga almashtiriladi, xolos. Bepul ta’mirlash
												xizmati xarid kunidan boshlab 100 kun ichida kelib
												chiqgan nuqsonlar uchun amal qiladi. Xarid qilinganiga
												100 kundan ortiq vaqt o‘tgan hech bir qurilmada kelib
												chiqgan nuqsonlar uchun CredoMobile kafolat va bepul
												servis xizmatini zimmasiga olmaydi. Bunday holatda
												xaridor pullik servislarga murojaat qilishga haqli
											</p>

											<p>
												<b>6.</b> Kafolat bo‘yicha servis xizmati ko‘rsatilishi
												uchun, siz nuqsonli, ammo yuqoridagi talablarga mos
												keluvchi qurilmangizni CredoMobile’da qoldirib
												ketishingiz kerak bo‘ladi. Ya’ni, uni shu zahotiyoq
												tuzatib yoki ishlamayotgan qismini almashtirib bera
												olinmaydi. Qancha muddatga qoldirish kerakligi esa
												Qurilmaning nuqsoni qay darajada ekanligidan kelib
												chiqib, ma’lum qilinadi.
											</p>
											<p>
												<b>7.</b> Sotilgan har bir planshetning jismoniy sim
												karta slotlarining IMEI kodlari sotuvchi tomonidan
												UZIMEI ro‘yxatidan o‘tkazib beriladi. Jismoniy sim karta
												sloti bo‘lmagan planshetlarning faqat bitta IMEI kodi
												UZIMEI’dan ro‘yxatdan o‘tkazib beriladi. Jismoniy
												bo‘lmagan ikkinchi sim karta sloti uchun IMEI kodlarini
												ro‘yxatdan o‘tkazishni sotuvchi o‘z majburiyatiga
												olmaydi. Bunday IMEI kodlarni xaridor xohishiga ko‘ra
												pullik xizmat ko‘rsatuvchilardan o‘zi ro‘yxatdan
												o‘tkazib olishga haqli.
											</p>
										</div>
									)}

									{isNoutbuk && (
										<div>
											<p>
												<b>2.</b> Qurilmaning ichi ochilmagan bo‘lishi shart.
												Buni bilish unchalik qiyin emas – har bir qurilmaning
												hali ochilmaganligini bildiruvchi plombalari mavjud.
											</p>
											<div>
												<p>
													<b>3.</b> Agarda qurilmaning tashqi nuqsoni bo‘lsa,
													unga servis xizmati ko‘rsatishmaydi. Deylik,
													qurilmaning korpusining bir burchagida ozgina qirilgan
													yoki pachoq bo’lgan iz bor. Agarda shu holida uning
													boshqa bir qismi, masalan, kamerasi yaxshi
													ishlamayotgan bo‘lsa ham, CredoMobile unga kafolat
													xizmati ko‘rsatishmaydi. Sababi oddiy – ekrandagi
													qirilish qurilmani siz yerga tushirib yuborganingiz
													yoki qattiqroq biror narsaga urib olganingizni
													anglatadi. O‘z-o‘zidan ma’lumki, kamerasi ham o‘shanda
													buzilib qolgan bo’lishi mumkin – unga servis xizmati
													ko‘rsatishni esa ishlab chiqaruvchi o‘z zimmasiga
													olmaydi.
												</p>
											</div>
											<p>
												<b>4.</b> Qurilmaning dasturiy ta’minotiga nolegal
												o‘zgartirish kiritilmagan bo‘lishi lozim.
												Masalan, Windows aktivatsiyasini buzish, BIOS
												parollarini buzish, ishlab chiqaruvchi unga servis
												xizmati ko‘rsatishni rad etishga haqli. Zero, shu kabi
												o‘zgartirishlar qurilmaning ayrim qismlari yoki
												operatsion tizimi ishdan chiqishiga olib keladi va
												bunday hollar uchun CredoMobile mas’ul bo‘lmaydi. Beta
												versiyadagi operatsion tizimlar o’rnatilgan qurilmaga
												ham kafolat berilmaydi.
											</p>
											<p>
												<b>5.</b> Xarid qilingan telefon uchun sotib olingan
												kundan boshlab 3 kun muddat ichida biror texnik
												nuqsonlar (xaridorning ta’sirisiz) kelib chiqqan
												taqdirda boshqa xuddi shunday qurilmaga almashtirib
												berish yo’li bilan kafolat beriladi. Xarid qilinganiga 3
												kundan ortiq vaqt o’tib CredoMobile ga nuqson bilan olib
												borilgan hech bir qurilmaning o‘zi yangisiga(boshqasiga)
												almashtirib berilmaydi, balki uning nuqsonli qismi
												(kamera, ekran, USB-port yoki boshqa joyi) yangisiga
												almashtiriladi, xolos. Bepul ta’mirlash xizmati xarid
												kunidan boshlab 12 oy ichida kelib chiqgan nuqsonlar
												uchun amal qiladi. Xarid qilinganiga 12 oydan ortiq vaqt
												o’tgan hech bir qurilmada kelib chiqgan nuqsonlar uchun
												CredoMobile kafolat va bepul serviz xizmatini zimmasiga
												olmaydi. Bunday holatda xaridor pullik servislarga
												murojaat qilishga haqli.
											</p>

											<p>
												<b>6.</b> Kafolat bo‘yicha servis xizmati ko‘rsatilishi
												uchun, siz nuqsonli, ammo yuqoridagi talablarga mos
												keluvchi qurilmangizni CredoMobile da qoldirib
												ketishingiz kerak bo‘ladi. Ya’ni, uni shu zahotiyoq
												tuzatib yoki ishlamayotgan qismini almashtirib bera
												olinmaydi. Qancha muddatga qoldirish kerakligi esa
												Qurilmaning nuqsoni qay darajada ekanligidan kelib
												chiqib, ma’lum qilinadi.
											</p>
										</div>
									)}
									{isTechnique && (
										<div>
											<p>
												<b>2.</b> Texnikaning ichi ochilmagan bo‘lishi shart.
												Buni bilish unchalik qiyin emas – har bir texnikaning
												hali ochilmaganligini bildiruvchi plombalari mavjud
											</p>
											<div>
												<p>
													<b>3.</b> Agarda texnikaning tashqi nuqsoni bo‘lsa,
													unga servis xizmati ko‘rsatishmaydi. Deylik, texnika
													korpusining bir burchagida ozgina qirilgan yoki pachoq
													bo’lgan iz bor. Agarda shu holida uning boshqa bir
													qismi, masalan, ekrani yoki boshqa qismi yaxshi
													ishlamayotgan bo‘lsa ham, CredoMobile unga kafolat
													xizmati ko‘rsatishmaydi. Sababi oddiy – korpusdagi
													qirilish texnikani siz yerga tushirib yuborganingiz
													yoki qattiqroq biror narsaga urib olganingizni
													anglatadi. O‘z-o‘zidan ma’lumki, texnikani boshqa
													qismi ham o‘shanda buzilib qolgan – unga servis
													xizmati ko‘rsatishni esa ishlab chiqaruvchi o‘z
													zimmasiga olmaydi.
												</p>
											</div>
											<p>
												<b>4.</b> Xarid qilingan texnika uchun sotib olingan
												kundan boshlab 3 kun muddat ichida biror texnik
												nuqsonlar (xaridorning ta’sirisiz) kelib chiqqan
												taqdirda boshqa xuddi shunday texnikaga almashtirib
												berish yo’li bilan kafolat beriladi. Xarid qilinganiga 3
												kundan ortiq vaqt o’tib CredoMobile ga nuqson bilan olib
												borilgan hech bir texnikaning o‘zi yangisiga(boshqasiga)
												almashtirib berilmaydi, balki uning nuqsonli qismining
												o’zigina yangisiga almashtiriladi, xolos. Bepul
												ta’mirlash xizmati xarid kunidan boshlab 30 kun ichida
												kelib chiqgan nuqsonlar uchun amal qiladi. Xarid
												qilinganiga 30 kundan ortiq vaqt o’tgan hech bir
												texnikada kelib chiqgan nuqsonlar uchun CredoMobile
												kafolat va bepul serviz xizmatini zimmasiga olmaydi.
												Bunday holatda xaridor pullik servislarga murojaat
												qilishga haqli.
											</p>
											<p>
												<b>5.</b> Kafolat bo‘yicha servis xizmati ko‘rsatilishi
												uchun, siz nuqsonli, ammo yuqoridagi talablarga mos
												keluvchi texnikangizni CredoMobile da qoldirib
												ketishingiz kerak bo‘ladi. Ya’ni, uni shu zahotiyoq
												tuzatib yoki ishlamayotgan qismini almashtirib bera
												olinmaydi. Qancha muddatga qoldirish kerakligi esa
												Qurilmaning nuqsoni qay darajada ekanligidan kelib
												chiqib, ma’lum qilinadi.
											</p>
										</div>
									)}
									<div className="mt-10">
										<p className="font-bold">
											Kafolat shartlari bilan to’liq tanishib chiqdim va shu
											shartlar asosida xarid qilishga roziman. __________(imzo)
										</p>
									</div>
									<div className="flex w-full mt-12 font-bold">
										<hr className="w-full border-t font-bold border-black" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</Spin>
			</DownloadStyle>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Layout>
	)
}

export default Download
